// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/user/components/UserVerifiedBadge.module.css';
import {VerifiedBadgeIcon} from '@app/features/ui/components/icons/VerifiedBadgeIcon';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import type {User} from '@app/features/user/models/User';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

const VERIFIED_USER_DESCRIPTOR = msg({
	message: 'Verified Account',
	comment: 'Tooltip for the verified checkmark shown next to a verified user display name.',
});

interface UserVerifiedBadgeProps {
	user: User;
	size?: number;
	className?: string;
}

export const UserVerifiedBadge = observer(function UserVerifiedBadge({
	user,
	size = 14,
	className,
}: UserVerifiedBadgeProps) {
	const {i18n} = useLingui();
	if (!user.isVerified()) return null;
	return (
		<Tooltip text={i18n._(VERIFIED_USER_DESCRIPTOR)}>
			<span className={clsx(styles.badge, className)} aria-label={i18n._(VERIFIED_USER_DESCRIPTOR)}>
				<VerifiedBadgeIcon size={size} />
			</span>
		</Tooltip>
	);
});
